import type { ReactNode } from 'react';

/**
 * オン・オフの切り替え（押すたびに反転）。右に文言を添える。
 *
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 課題管理の画面で、CS向け表示やAIのおすすめのようなオン・オフを1クリックで切り替える
 * @graph-connects none
 */
export function ToggleSwitch({
  checked,
  onToggle,
  label,
  disabled = false,
  children,
}: {
  checked: boolean;
  onToggle: () => void;
  label?: string;
  disabled?: boolean;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={onToggle}
      className="flex items-center gap-2 text-sm text-[var(--color-text-secondary)] disabled:cursor-not-allowed disabled:opacity-60"
    >
      <span
        className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ${
          checked ? 'bg-[var(--color-accent-primary)]' : 'bg-[var(--color-border)]'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 rounded-full bg-white transition-transform ${
            checked ? 'translate-x-4' : 'translate-x-0.5'
          }`}
        />
      </span>
      {children}
    </button>
  );
}
